
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators/profile/[username]",
      function () {
        return require("private-next-pages/creators/profile/[username]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creators/profile/[username]"])
      });
    }
  